import React from "react";

import { getVumareachLocationDetails } from "./../../../Services/Services";

import "./VumaAddressSelector.css";

export const VumaAddressSelector = props => {
    const [addressEditMode, setAddressEditMode] = React.useState(true);
    const [selectedAddress, setSelectedAddress] = React.useState(props.selectedAddress || 'disabled');
    const [addressSearchResults, setAddressSearchResult] = React.useState([]);
    const [filteredAddressSearchResults, setFilteredAddressSearchResult] = React.useState([]);
    const [searchInput, setSearchInput] = React.useState('');
    const [showDropDown, setShowDropDown] = React.useState(false);
    const [isAddressStandAlone, setAddressStandAlone] = React.useState(false);

    const searchInputChangeHandler = event => {
        const searchResults = addressSearchResults.filter(e => e.name.indexOf(event.target.value) > -1);
        setFilteredAddressSearchResult(searchResults);
        setSearchInput(event.target.value);
    }

    const addressChangeHandler = value => {
        const addressObj = addressSearchResults.find(e => e.name === value);
        props.addressChangeHandler(addressObj);
        setSelectedAddress(value);
        setAddressEditMode(false);
        setShowDropDown(false);
    }

    const editButtonClickHandler = () => {
        setAddressEditMode(true);
        setSelectedAddress('disabled');
        props.addressChangeHandler(null);
    }

    React.useEffect(() => {
        props.setLoader(true);
         getVumareachLocationDetails(props.installationAddress.latitude, props.installationAddress.longitude)
             .then(data => {
                setAddressSearchResult(data.result.place);
                setFilteredAddressSearchResult(data.result.place);
                props.updateProgress('done');
                props.setLoader(false);
                if (data.result.place && data.result.place.length === 1) {
                    props.addressChangeHandler(data.result.place[0]);
                    setSelectedAddress(data.result.place[0].name);
                    setAddressEditMode(false);
                    setShowDropDown(false);
                    setAddressStandAlone(true);
                } else {
                    setAddressStandAlone(false);
                }
             })
             .catch(error => {
                 console.error(error);
                 props.setLoader(false);
                 props.updateProgress('error');
             });
    }, [])

    React.useEffect(() => {
        if (props.selectedAddress) {
            setSelectedAddress(props.selectedAddress);
            setAddressEditMode(false);
        } else {
            setSelectedAddress('disabled');
            setAddressEditMode(true);
        }
    }, [props.selectedAddress])


    return (
        <React.Fragment>
            <h3 automationid="SalesLead_H3_AS_01">Please confirm your address</h3>
            {addressEditMode && <div className="vumareach-plan-details-address-select-wrapper" automationid="SalesLead_Div_AS_02">
                <div className="vumareach-plan-details-address-select-container" automationid="SalesLead_Div_AS_03">
                    <input className="vumareach-plan-details-address-select-input"
                        automationid="SalesLead_Input_AS_02"
                        value={searchInput}
                        onChange={searchInputChangeHandler}
                        onFocus={() => setShowDropDown(!showDropDown)}
                        onBlur={() => setTimeout(() => setShowDropDown(false), 500)}
                        placeholder="Search or select your address..."
                    />
                    <div className="vumareach-plan-details-address-select-div" automationid="SalesLead_Div_AS_05">
                        {
                            showDropDown && filteredAddressSearchResults.map(e => <div
                                automationid={`SalesLead_Div_AS${e.id}_00`}
                                className="vumareach-plan-details-address-select-option" key={e.id}
                                onClick={addressChangeHandler.bind(this, e.name)}
                            >
                                {e.name}
                            </div>)
                        }
                    </div>
                    <span className="vumareach-plan-details-address-select-arrow" automationid="SalesLead_Div_AS_11">&#9660;</span>
                </div>
            </div>
            }

            <div automationid="SalesLead_Div_AS_32" className={`vumareach-plan-details-address " ${addressEditMode ? "" : "vumareach-plan-details-address-selected"}`}>
                {
                    addressEditMode ? <span automationid="SalesLead_Span_AS_50">Choose your unit number above...</span> : <React.Fragment>
                        <div style={isAddressStandAlone ? { maxWidth: "20rem", margin: 'auto' } : { maxWidth: "20rem", marginBottom: "1rem" }} automationid="SalesLead_Div_AS_100">{selectedAddress}</div>
                        {!isAddressStandAlone && <button automationid="SalesLead_Button_AS_02" className="vumareach-plan-details-address-button" onClick={editButtonClickHandler}>EDIT</button>}
                    </React.Fragment>
                }

            </div>
        </React.Fragment>
    )
}